<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb" style="padding-top: 20px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
        >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          {{ $t("app.modules.reports.title") }}
        </el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
      </el-breadcrumb>
      <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
    </div>
    <el-divider></el-divider>

    <div
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <h4 class="card-title text-purple">
        {{ $t("app.modules.reports.open_invoices") }}
      </h4>
      
      <div class="text-right">
          <n-button type="info" round @click.native="exportExcel">
            {{ $t("app.buttons.excel") }}
          </n-button>
        </div>

    </div>

    <el-table stripe style="width: 100%;" :data="account">
      <el-table-column
        prop="facturaComercial"
        :label="this.$t('app.modules.reports.headers.assignment')"
        sortable
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="fechaFaturacion"
        :label="this.$t('app.modules.reports.headers.document_date')"
        sortable
        min-width="150"
        
      >
      </el-table-column>
      <el-table-column
        prop="fechaVencimiento"
        :label="this.$t('app.modules.reports.headers.payment_date')"
        sortable
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        prop="monto"
        :label="this.$t('app.modules.reports.headers.amount')"
        sortable
        align="right"
      >

      <template slot-scope="scope">
          {{ scope.row.monto | currencyFormat }} 
        </template>

      </el-table-column>
      <el-table-column
        prop="moneda"
        :label="this.$t('app.modules.reports.headers.currency')"
        sortable
        align="right"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

/*
import { XlsxDownload, XlsxSheet, XlsxWorkbook } from 'vue-xlsx'

export default {
  name: "OpenInvoiceReport",
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data () {
    return {
      items: [{"assignment":"53346-1365","document_date":"2021-04-14","payment_date":"2021-03-12","amount":830,"currency":"IDR"},
        {"assignment":"59779-583","document_date":"2021-09-27","payment_date":"2021-07-09","amount":680,"currency":"CNY"},
        {"assignment":"64679-920","document_date":"2021-05-06","payment_date":"2021-09-05","amount":280,"currency":"PLN"},
        {"assignment":"37808-405","document_date":"2020-10-23","payment_date":"2021-04-22","amount":10,"currency":"PEN"},
        {"assignment":"54868-6310","document_date":"2021-02-15","payment_date":"2021-02-01","amount":750,"currency":"PLN"},
        {"assignment":"35356-727","document_date":"2021-05-12","payment_date":"2020-10-09","amount":280,"currency":"CNY"},
        {"assignment":"43419-516","document_date":"2021-03-16","payment_date":"2021-01-31","amount":780,"currency":"PLN"},
        {"assignment":"43063-519","document_date":"2020-09-30","payment_date":"2020-10-12","amount":620,"currency":"CNY"},
        {"assignment":"61722-081","document_date":"2020-09-28","payment_date":"2021-04-25","amount":420,"currency":"CZK"},
        {"assignment":"52490-200","document_date":"2021-05-26","payment_date":"2021-01-30","amount":210,"currency":"RUB"}],
      excel: []
    }
  },
  computed: {
    excelName () {
      return this.$t("app.modules.reports.title") + ' ' + this.$t("app.modules.reports.open_invoices") + '.xlsx'
    },
    excelData () {
      return [{
        name: this.excelName,
        data: this.items.map(item => {
          let el = new Map([
            [this.$t('app.modules.reports.headers.assignment'), item.assignment],
            [this.$t('app.modules.reports.headers.document_date'), item.document_date],
            [this.$t('app.modules.reports.headers.payment_date'), item.payment_date],
            [this.$t('app.modules.reports.headers.amount'), item.amount],
            [this.$t('app.modules.reports.headers.currency'), item.currency]
          ])

          return Object.fromEntries(el)
        })
      }]
    }
  }
};
*/

import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";
import { number_format, getResponse } from "@/util/utilities";
import { Direccion } from "@/models/pedidos/Direccion";
import XLSX from "xlsx";
export default {
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      tableData: [],
      currDate: new Date(),
      item: {},
      account: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      direccion: new Direccion(),
      headers: [
        this.$t('app.modules.reports.headers.assignment'),
        this.$t('app.modules.reports.headers.document_date'),
        this.$t('app.modules.reports.headers.payment_date'),
        this.$t('app.modules.reports.headers.amount'),
        this.$t('app.modules.reports.headers.currency')
      ]
    };    
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      // return this.account.reduce((acc, item) => acc + item.monto, 0);
      return this.account.length;
    },
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.getAccount();
    await this.getDireccionFiscal();

    this.$swal.close();
  },
  filters: {
    currencyFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    },
  },
  methods: {
    exportExcel() {
      let data = [this.headers].concat(this.getData());

      console.log("Objeto data" + JSON.stringify(data));
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, this.$t('app.modules.reports.filename_oi'));
    },
    getData(){
      let data = this.tableData;
      let _data = [];
      data.forEach(val => {
        let response = [];
        response.push(val.facturaComercial);
        response.push(val.fechaFaturacion);
        response.push(val.fechaVencimiento);
        response.push(val.monto);
        response.push(val.moneda);
        _data.push(response);
      });

      return _data;
    },
    number_format,
    async getAccount() {
      var payload = {
        id: this.$store.state.user.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("EstadoCuenta/getEC"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.account = response.body.estadosCuenta;
              this.tableData = response.body.estadosCuenta;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async savePDF() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      var payload = {
        id: this.item.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: 1,
        direccionFiscal: this.$t(
          "app.modules.account_statements.headers.fiscal_address"
        ),
        idClienteSAP: this.$t(
          "app.modules.account_statements.headers.client_id"
        ),
        facturaFiscal: this.$t(
          "app.modules.account_statements.headers.fiscal_bill"
        ),
        facturaComercial: this.$t(
          "app.modules.account_statements.headers.commercial_bill"
        ),
        fechaFaturacion: this.$t(
          "app.modules.account_statements.headers.bill_date"
        ),
        moneda: this.$t("app.modules.account_statements.headers.money"),
        monto: this.$t("app.modules.account_statements.headers.amount"),
        terminosPago: this.$t(
          "app.modules.account_statements.headers.payment_terms"
        ),
        fechaVencimiento: this.$t(
          "app.modules.account_statements.headers.expire_date"
        ),
      };

      await this.$http
        .post(route("EstadoCuenta/getEstadosCuentaClientePDF"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.report_url = response.body.ruta;
              console.log(this.report_url);
              window.open(this.report_url, "_blank");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});

      this.$swal.close();
    },
    getPDF() {
      // this.$router.push({ path: 'estado_cuenta_cliente_pdf', params: this.item })
      this.$refs.html2Pdf.generatePdf();
    },
    parseDatetime(dt) {
      console.log(dt);
      var year = dt.getFullYear();
      var month = (dt.getMonth() + 1).toString().padStart(2, "0");
      var day = dt.getDate().toString().padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    parseDateMoment(dt) {
      return moment(dt).format("YYYY/MM/DD");
    },
    getFechaVencimiento(fechaBase, terminos) {
      return moment(fechaBase).add(terminos, "days").format("YYYY/MM/DD");
    },
    async getDireccionFiscal() {
      var payload = {
        idClienteSAP: this.$store.state.user.idClienteSAP.toString(),
      };

      await this.$http
        .post(route("EstadoCuenta/getDireccionFiscalByClienteSAP"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.direccion = response.body.direcciones[0];
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    subtotal(movs) {
      return movs.reduce((acc, item) => acc + item, 0);
    },
    grantotal() {
      return this.tableData.reduce(
        (acc, item) => acc + this.subtotal(item.movimientos),
        0
      );
    },
    startPagination() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });
    },
    hasDownloaded($event) {
      this.$swal.close();
    },
  },
};



</script>

<style scoped>

</style>
